import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gwrvqatpd: FaireProductEntity = {
  token: "p_6gwrvqatpd",
  type: "product",
  name: "ALL THAT AIR - Breathable Mesh Ballet Flat, Split Toe Detail",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/fbc848c7ca5a148558bf0b1a0db4db900519bf5f451f28c5a131abe0742c87a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd57dd8ed04eb4a9487e208bcf2701a2ce7e651545a5287c3f32f1ab938f3df4.jpeg",
    "https://cdn.faire.com/fastly/0bcc7efd7f225e0ec2c3ee72508ae71d3e2429d5745bf5f22c8eef00766d9b00.jpeg",
    "https://cdn.faire.com/fastly/1aa04f9a231a5c04398205f10ba45f4cb6c99d8f8c8992ac7107a332a930ad2e.jpeg",
    "https://cdn.faire.com/fastly/e59d0268aa36a91f6d7d74faf8fafc562dd76d3b2261d67a52cabf85f7f198b2.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 13,
  description:
    "Light, breathable, and effortlessly cool. This mesh flat features a soft, flexible fit with a modern split-toe detail that gives it that understated edge. Easy to slip on and style, it’s the perfect balance of minimal and statement—aka your new everyday go-to. Please note: slight color shift may occur depending on lighting.\n\nOOTD\nPair with linen trousers and a fitted tank for an easy, airy look, or style with a flowy midi skirt for something a little softer. Add a woven tote or sleek sunglasses to complete the vibe.",
  tags: [],
  msrpDollars: 26,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:10.622Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
